import React, { useEffect, useState } from "react";
import axios from "axios";
import "./procesosViewer.css";
import ListadoInscriptosEtapa from "./ListadoInscriptosEtapa";
import LectorQrPresente from "./LectorQrPresente";
import TurnosRecursivas from "./TurnosRecursivas";
import EstadisticasProceso from "./EstadisticasProceso";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos.js";
import * as XLSX from "xlsx";
const API = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";
const ProcesosViewer = () => {
  const Usuario = ObtieneDatosCookies();
  const [procesos, setProcesos] = useState([]);
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);
  const [formularioIdSeleccionado, setFormularioIdSeleccionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [etapaAbierta, setEtapaAbierta] = useState(null);
  // Módulo visible dentro del proceso seleccionado
  const [moduloProceso, setModuloProceso] = useState("etapas");
  // Estadísticas: únicamente dependencia 7 o permiso específico.
  const puedeVerEstadisticas =
    Number(Usuario?.destino) === 7 ||
    String(Usuario?.funcion || "")
      .split(",")
      .some((permiso) =>
        permiso.trim().toLowerCase() === "veo estadistica de procesos"
      );
  // Solo procesos cuyo campo Tipo sea exactamente "Ingreso".
  const esProcesoIngreso =
    String(procesoSeleccionado?.Tipo ?? procesoSeleccionado?.tipo ?? "")
      .trim()
      .toLowerCase() === "ingreso";

  const mostrarEstadisticas = puedeVerEstadisticas && esProcesoIngreso;

  const [modalPresente, setModalPresente] = useState(false);
  const [etapaPresente, setEtapaPresente] = useState(null);
  // =====================================================
  // PRESENTE RECIÉN MARCADO
  // =====================================================
  // Lo usamos para actualizar ListadoInscriptosEtapa
  // inmediatamente, sin volver a consultar el backend.
  const [presenteNuevo, setPresenteNuevo] = useState(null);
  const [modalMatricula, setModalMatricula] = useState(false);
  const [etapaSeleccionada, setEtapaSeleccionada] = useState(null);
  const [dnisTexto, setDnisTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
 const tienePermisoSuperior = comprueboPermisos(
  Usuario?.funcion,
  "Escuela Superior"
);
const tienePermisoEspecialidades = comprueboPermisos(
  Usuario?.funcion,
  "Escuela de Especialidades"
);
const tienePermisoPolicia = comprueboPermisos(
  Usuario?.funcion,
  "Escuela de Policia"
);

const tienePermisoInvestigaciones = comprueboPermisos(
  Usuario?.funcion,
  "Escuela de Investigaciones"
);

const tienePermisoIngresos = comprueboPermisos(
  Usuario?.funcion,
  "Veo Procesos de Ingreso"
);
// =====================================================
// DEPENDENCIA QUE REGISTRA EL PRESENTE
// =====================================================
// Si el usuario pertenece al Area de Inscripcion, los presentes
// quedan identificados como Area Inscripcion Alumnado.
// Para las escuelas, usamos el nombre de la escuela del proceso
// seleccionado, de modo que Especialidades, Superior y las demas
// escuelas queden diferenciadas automaticamente.
const obtenerDependenciaPresente = () => {
  if (tienePermisoIngresos) {
    return "Area Inscripcion Alumnado";
  }
  const escuelaProceso = String(
    procesoSeleccionado?.escuela || ""
  ).trim();
  if (escuelaProceso) {
    return escuelaProceso;
  }
  // Fallback por si getProcesoCompleto no trae escuela.
  if (tienePermisoEspecialidades) {
    return "Escuela de Especialidades";
  }
  if (tienePermisoSuperior) {
    return "Escuela Superior";
  }
  return (
    Usuario?.destino ||
    Usuario?.dependencia ||
    "Procesos"
  );
};
const descargarExcelPostulaciones = async () => {
  let intervaloAnimacion = null;
  let intervaloMensajes = null;
  try {
    const formularioId =
      formularioIdSeleccionado ||
      procesoSeleccionado?.formularioId ||
      procesoSeleccionado?.formulario_id ||
      null;
    if (!formularioId) {
      Swal.fire(
        "Atención",
        "No se pudo determinar el formulario para este proceso",
        "warning"
      );
      return;
    }
    let cantidadPuntos = 0;
    let mensajeActual = 0;
    const mensajes = [
      "Consultando postulaciones",
      "Procesando información personal",
      "Tecnologia y Desarrollo haciendo magia",
      "Preparando filas del documento",
      "Construyendo archivo Excel",
    ];
    Swal.fire({
      title: `
        <div class="excel-cinematic-title">
          GENERANDO ARCHIVO
        </div>
      `,
      html: `
        <div class="excel-cinematic-container">
          <div class="excel-cinematic-icon">
            📊
          </div>
          <div class="excel-cinematic-process">
            <span id="excel-mensaje">
              ${mensajes[0]}
            </span>
            <span id="excel-puntos"></span>
          </div>
          <div
            id="excel-progreso-texto"
            class="excel-cinematic-count"
          >
            Preparando consulta...
          </div>
          <div class="excel-cinematic-bar">
            <div
              id="excel-barra-real"
              class="excel-cinematic-progress"
            ></div>
          </div>
          <div class="excel-cinematic-description">
            Inscriptos al proceso:
            <strong>
              ${
                procesoSeleccionado?.nombre ||
                "Proceso seleccionado"
              }
            </strong>
          </div>
          <div class="excel-cinematic-warning">
            No cierre esta ventana
          </div>
        </div>
        <style>
          .swal2-popup.excel-cinematic-popup {
            width: 520px;
            padding: 30px;
            border: 1px solid rgba(77, 171, 247, 0.35);
            border-radius: 22px;
            background:
              radial-gradient(
                circle at top,
                rgba(54, 89, 161, 0.35),
                transparent 45%
              ),
              linear-gradient(
                145deg,
                #081120,
                #111f35
              );
            color: white;
            box-shadow:
              0 0 40px rgba(54, 89, 161, 0.35),
              0 30px 80px rgba(0, 0, 0, 0.5);
          }
          .excel-cinematic-title {
            color: #ffffff;
            font-size: 21px;
            font-weight: 900;
            letter-spacing: 4px;
            text-shadow:
              0 0 8px rgba(92, 178, 255, 0.8),
              0 0 18px rgba(54, 89, 161, 0.7);
          }
          .excel-cinematic-container {
            padding: 8px 5px 0;
            text-align: center;
          }
          .excel-cinematic-icon {
            margin: 15px 0;
            font-size: 58px;
            animation:
              excelFlotar
              1.8s
              ease-in-out
              infinite;
            filter:
              drop-shadow(
                0 0 14px
                rgba(78, 190, 130, 0.75)
              );
          }
          .excel-cinematic-process {
            min-height: 30px;
            margin-top: 12px;
            color: #dcecff;
            font-size: 17px;
            font-weight: 700;
            letter-spacing: 0.4px;
          }
          #excel-puntos {
            display: inline-block;
            width: 24px;
            text-align: left;
          }
          .excel-cinematic-count {
            margin-top: 10px;
            color: #8fb9df;
            font-size: 12px;
            font-weight: 700;
          }
          .excel-cinematic-bar {
            position: relative;
            overflow: hidden;
            height: 9px;
            margin: 18px 0 18px;
            border:
              1px solid
              rgba(120, 190, 255, 0.25);
            border-radius: 999px;
            background:
              rgba(255, 255, 255, 0.08);
          }
          .excel-cinematic-progress {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 0%;
            border-radius: 999px;
            background:
              linear-gradient(
                90deg,
                #4dabf7,
                #63e6be
              );
            box-shadow:
              0 0 10px #4dabf7,
              0 0 20px rgba(77, 171, 247, 0.8);
            transition:
              width 0.35s ease;
          }
          .excel-cinematic-description {
            color: #b9c9dc;
            font-size: 13px;
            line-height: 1.6;
          }
          .excel-cinematic-description strong {
            display: block;
            margin-top: 4px;
            color: #ffffff;
            font-size: 14px;
          }
          .excel-cinematic-warning {
            margin-top: 18px;
            color: #7fa6cc;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
          }
          .swal2-loader {
            display: none !important;
          }
          @keyframes excelFlotar {
            0%,
            100% {
              transform:
                translateY(0)
                scale(1);
            }
            50% {
              transform:
                translateY(-8px)
                scale(1.06);
            }
          }
        </style>
      `,
      customClass: {
        popup: "excel-cinematic-popup",
      },
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        intervaloAnimacion =
          setInterval(() => {
            cantidadPuntos =
              (cantidadPuntos + 1) % 4;
            const elementoPuntos =
              Swal
                .getHtmlContainer()
                ?.querySelector(
                  "#excel-puntos"
                );
            if (elementoPuntos) {
              elementoPuntos.textContent =
                ".".repeat(
                  cantidadPuntos
                );
            }
          }, 400);
        intervaloMensajes =
          setInterval(() => {
            mensajeActual =
              (mensajeActual + 1) %
              mensajes.length;
            const elementoMensaje =
              Swal
                .getHtmlContainer()
                ?.querySelector(
                  "#excel-mensaje"
                );
            if (elementoMensaje) {
              elementoMensaje.style.opacity =
                "0";
              setTimeout(() => {
                elementoMensaje.textContent =
                  mensajes[
                    mensajeActual
                  ];
                elementoMensaje.style.transition =
                  "opacity 0.35s ease";
                elementoMensaje.style.opacity =
                  "1";
              }, 200);
            }
          }, 1900);
      },
      willClose: () => {
        if (intervaloAnimacion) {
          clearInterval(
            intervaloAnimacion
          );
        }
        if (intervaloMensajes) {
          clearInterval(
            intervaloMensajes
          );
        }
      },
    });
    // =========================================================
    // TRAER POSTULACIONES POR PÁGINAS
    // =========================================================
    const limitePorPagina = 2000;
    let pagina = 1;
    let totalPaginas = 1;
    let totalRegistros = 0;
    let postulaciones = [];
    do {
      const res = await axios.post(
        `${API}/listarPostulacionesPlano`,
        null,
        {
          params: {
            formulario_id:
              formularioId,
            page:
              pagina,
            limit:
              limitePorPagina,
          },
        }
      );
      const datosPagina =
        res.data?.data || [];
      totalPaginas =
        Number(
          res.data?.totalPages
        ) || 1;
      totalRegistros =
        Number(
          res.data?.total
        ) || 0;
      postulaciones.push(
        ...datosPagina
      );
      // =======================================================
      // ACTUALIZAR PROGRESO
      // =======================================================
      const porcentaje =
        Math.min(
          Math.round(
            (
              pagina /
              totalPaginas
            ) * 100
          ),
          100
        );
      const barra =
        Swal
          .getHtmlContainer()
          ?.querySelector(
            "#excel-barra-real"
          );
      if (barra) {
        barra.style.width =
          `${porcentaje}%`;
      }
      const progresoTexto =
        Swal
          .getHtmlContainer()
          ?.querySelector(
            "#excel-progreso-texto"
          );
      if (progresoTexto) {
        progresoTexto.textContent =
          totalRegistros
            ? `${postulaciones.length} de ${totalRegistros} postulaciones`
            : `${postulaciones.length} postulaciones procesadas`;
      }
      pagina++;
    } while (
      pagina <= totalPaginas
    );
    // =========================================================
    // SIN POSTULACIONES
    // =========================================================
    if (
      postulaciones.length === 0
    ) {
      Swal.fire({
        icon: "info",
        title: "Sin datos",
        text:
          "No hay postulaciones para exportar",
      });
      return;
    }
    // =========================================================
    // AUXILIAR PARA HIJOS
    // =========================================================
    const formatearHijos = (
      hijos
    ) => {
      if (
        !Array.isArray(hijos) ||
        hijos.length === 0
      ) {
        return "";
      }
      return hijos
        .map(
          (
            hijo,
            index
          ) => {
            const partes = [];
            if (
              hijo.nombre_y_apellido
            ) {
              partes.push(
                hijo.nombre_y_apellido
              );
            }
            if (hijo.nombre) {
              partes.push(
                hijo.nombre
              );
            }
            if (
              hijo.apellido &&
              !hijo.nombre_y_apellido
            ) {
              partes.push(
                hijo.apellido
              );
            }
            if (
              hijo.DNI ||
              hijo.dni
            ) {
              partes.push(
                `DNI: ${
                  hijo.DNI ||
                  hijo.dni
                }`
              );
            }
            if (
              hijo.fecha_nacimiento
            ) {
              partes.push(
                `Nacimiento: ${hijo.fecha_nacimiento}`
              );
            }
            if (
              hijo.vinculo
            ) {
              partes.push(
                `Vínculo: ${hijo.vinculo}`
              );
            }
            if (
              hijo.convive !==
              undefined &&
              hijo.convive !==
              null
            ) {
              const convive =
                hijo.convive === true ||
                hijo.convive === 1 ||
                hijo.convive === "1" ||
                String(
                  hijo.convive
                ).toLowerCase() ===
                  "true"
                  ? "Sí"
                  : "No";
              partes.push(
                `Convive: ${convive}`
              );
            }
            return partes.length
              ? `Hijo ${
                  index + 1
                }: ${partes.join(
                  " - "
                )}`
              : "";
          }
        )
        .filter(Boolean)
        .join(" | ");
    };
    // =========================================================
    // AUXILIAR PARA EXPERIENCIA
    // =========================================================
    const formatearExperiencia = (
      experiencias
    ) => {
      if (
        !Array.isArray(
          experiencias
        ) ||
        experiencias.length === 0
      ) {
        return "";
      }
      return experiencias
        .map(
          (
            experiencia,
            index
          ) => {
            const partes = [];
            const camposIgnorados = [
              "id",
              "persona_id",
              "createdAt",
              "updatedAt",
            ];
            Object.entries(
              experiencia
            ).forEach(
              ([clave, valor]) => {
                if (
                  camposIgnorados.includes(
                    clave
                  )
                ) {
                  return;
                }
                if (
                  valor === null ||
                  valor === undefined ||
                  valor === ""
                ) {
                  return;
                }
                let valorFinal =
                  valor;
                if (
                  valor === true ||
                  valor === "true" ||
                  valor === 1
                ) {
                  valorFinal = "Sí";
                }
                if (
                  valor === false ||
                  valor === "false" ||
                  valor === 0
                ) {
                  valorFinal = "No";
                }
                const claveBonita =
                  String(clave)
                    .replace(
                      /_/g,
                      " "
                    )
                    .replace(
                      /([a-z])([A-Z])/g,
                      "$1 $2"
                    )
                    .trim();
                partes.push(
                  `${claveBonita}: ${valorFinal}`
                );
              }
            );
            return partes.length
              ? `Experiencia ${
                  index + 1
                }: ${partes.join(
                  " - "
                )}`
              : "";
          }
        )
        .filter(Boolean)
        .join(" | ");
    };
    // =========================================================
    // ARMAR FILAS EXCEL
    // =========================================================
    const filas =
      postulaciones.map(
        (item) => {
          const fila = {
            postulacion_id:
              item.postulacion_id,
            completo:
              item.completo ||
              "No completo",
            dni:
              item.persona?.dni ||
              "",
            apellido:
              item.persona
                ?.apellido ||
              "",
            nombre:
              item.persona?.nombre ||
              "",
            email:
              item.persona?.email ||
              "",
          };
          // ===================================================
          // CAMPOS DEL FORMULARIO
          // ===================================================
          Object.entries(
            item.legajo || {}
          ).forEach(
            ([
              seccion,
              campos,
            ]) => {
              Object.entries(
                campos || {}
              ).forEach(
                ([
                  campo,
                  valor,
                ]) => {
                  fila[
                    `${seccion} - ${campo}`
                  ] =
                    valor ??
                    "";
                }
              );
            }
          );
          // ===================================================
          // HIJOS
          // ===================================================
          fila.hijos =
            formatearHijos(
              item.hijos
            );
          // ===================================================
          // EXPERIENCIA
          // ===================================================
          fila.experiencia =
            formatearExperiencia(
              item.experiencia
            );
          return fila;
        }
      );
    // =========================================================
    // CREAR HOJA
    // =========================================================
    const ws =
      XLSX.utils.json_to_sheet(
        filas
      );
    // =========================================================
    // ANCHO DE COLUMNAS
    // =========================================================
    const columnas =
      Object.keys(
        filas[0] || {}
      );
    ws["!cols"] =
      columnas.map(
        (columna) => {
          if (
            columna ===
            "postulacion_id"
          ) {
            return {
              wch: 16,
            };
          }
          if (
            columna ===
            "completo"
          ) {
            return {
              wch: 15,
            };
          }
          if (
            columna ===
            "dni"
          ) {
            return {
              wch: 14,
            };
          }
          if (
            columna ===
            "apellido" ||
            columna ===
            "nombre"
          ) {
            return {
              wch: 25,
            };
          }
          if (
            columna ===
            "email"
          ) {
            return {
              wch: 35,
            };
          }
          if (
            columna ===
            "hijos" ||
            columna ===
            "experiencia"
          ) {
            return {
              wch: 60,
            };
          }
          return {
            wch: 32,
          };
        }
      );
    // =========================================================
    // CREAR LIBRO
    // =========================================================
    const wb =
      XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Postulaciones"
    );
    // =========================================================
    // NOMBRE ARCHIVO
    // =========================================================
    const nombreProceso =
      procesoSeleccionado
        ?.nombre
        ?.trim() ||
      `proceso_${
        procesoSeleccionado?.id ||
        "sin_id"
      }`;
    const nombreArchivo =
      `inscriptos_${nombreProceso}.xlsx`
        .replace(
          /[**\\\\\\**/:*?"<>|]/g,
          "_"
        );
    // =========================================================
    // DESCARGAR
    // =========================================================
    XLSX.writeFile(
      wb,
      nombreArchivo
    );
    // =========================================================
    // FINAL
    // =========================================================
    Swal.fire({
      icon: "success",
      title:
        "Archivo completado",
      html: `
        <strong>
          ${postulaciones.length}
        </strong>
        postulaciones fueron procesadas correctamente.
      `,
      confirmButtonText:
        "Excelente",
      confirmButtonColor:
        "#3659a1",
    });
  } catch (error) {
    console.error(
      "Error generando Excel:",
      error
    );
    Swal.fire({
      icon: "error",
      title:
        "Falló la generación",
      text:
        error.response?.data?.error ||
        error.response?.data?.message ||
        "No se pudo generar el archivo Excel",
    });
  } finally {
    if (intervaloAnimacion) {
      clearInterval(
        intervaloAnimacion
      );
    }
    if (intervaloMensajes) {
      clearInterval(
        intervaloMensajes
      );
    }
  }
};
const filtrarProcesosPorPermiso = (lista) => {
  return (lista || []).filter((proceso) => {
    const escuela = String(
      proceso?.Escuela ||
      proceso?.escuela ||
      ""
    ).toLowerCase();

    const esSuperior =
      escuela.includes("escuela superior");

    const esEspecialidades =
      escuela.includes("escuela de especialidades");

    const esPolicia =
      escuela.includes("escuela de policia") ||
      escuela.includes("escuela de policía");

    const esInvestigaciones =
      escuela.includes("escuela de investigaciones");

    if (esSuperior) {
      return tienePermisoSuperior;
    }

    if (esEspecialidades) {
      return tienePermisoEspecialidades;
    }

    if (esPolicia) {
      return tienePermisoPolicia;
    }

    if (esInvestigaciones) {
      return tienePermisoInvestigaciones;
    }

    return tienePermisoIngresos;
  });
};

  const cargarProcesos = async () => {
    try {
      const res = await axios.post(`${API}/listarProcesos`);

     

      setProcesos(filtrarProcesosPorPermiso(res.data));
    } catch (err) {
      console.error(err);
    }
  };

  const abrirProceso = async (proceso) => {
    setLoading(true);
    Swal.fire({
      title: "Cargando proceso...",
      text: "Por favor espere",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const res = await axios.post(`${API}/getProcesoCompleto`, {
        proceso_id: proceso.id,
      });
      const procesoCompleto = res.data;
      // Conservamos el Tipo del listado si el endpoint completo no lo devuelve.
      setProcesoSeleccionado({
        ...procesoCompleto,
        Tipo: procesoCompleto?.Tipo ?? procesoCompleto?.tipo ?? proceso?.Tipo ?? proceso?.tipo,
      });
      setFormularioIdSeleccionado(
        procesoCompleto?.formularioId ||
        procesoCompleto?.formulario_id ||
        proceso?.formularioId ||
        proceso?.formulario_id ||
        null
      );
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cargar el proceso",
      });
    } finally {
      setLoading(false);
      Swal.close();
    }
  };
  useEffect(() => {
    cargarProcesos();
  }, []);
  const parseDnis = (texto) => {
    return texto
      .split(/[\s,;\n]+/)
      .map((d) => d.trim())
      .filter((d) => d.length > 0);
  };
  const enviarMatricula = async () => {
    const dnis = parseDnis(dnisTexto);
    if (dnis.length === 0) {
      Swal.fire("Atención", "Ingresá al menos un DNI", "warning");
      return;
    }
    setEnviando(true);
    try {
      await axios.post(`${API}/inscribirMasivoEtapa`, {
        dnis,
        proceso_id: procesoSeleccionado.id,
        proceso_etapa_id: etapaSeleccionada.id,
        usuario_id: Usuario.identificacion,
  usuario_nombre: `${Usuario.apellido}, ${Usuario.nombre}`,
      });
      Swal.fire("Correcto", "Matriculación exitosa", "success");
      setModalMatricula(false);
      setDnisTexto("");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Error al matricular", "error");
    } finally {
      setEnviando(false);
    }
  };
  if (procesoSeleccionado) {
    return (
      <div className="pv-container">
        {modalPresente && (
          <div className="pv-modal-overlay">
            <div className="pv-modal">
              <h3>📷 Marcar presente</h3>
              <p>
                Etapa: <b>{etapaPresente?.nombre}</b>
              </p>
              <p style={{ marginTop: 4, opacity: 0.8 }}>
                Dependencia: <b>{obtenerDependenciaPresente()}</b>
              </p>
              <LectorQrPresente
                etapa_id={etapaPresente?.id}
                dependencia={obtenerDependenciaPresente()}
                onPresenteMarcado={(registro) => {
                  // El backend ya devolvió el registro creado.
                  // Se lo pasamos al listado para pintarlo
                  // inmediatamente sin volver a consultar.
                  setPresenteNuevo({
                    ...registro,
                    dni: String(
                      registro?.dni || ""
                    ).trim(),
                    proceso_etapa_id:
                      registro?.proceso_etapa_id ||
                      etapaPresente?.id,
                    dependencia:
                      registro?.dependencia ||
                      obtenerDependenciaPresente(),
                  });
                }}
                onClose={() => {
                  setModalPresente(false);
                  setEtapaPresente(null);
                }}
              />
            </div>
          </div>
        )}
        {modalMatricula && (
          <div className="pv-modal-overlay">
            <div className="pv-modal">
              <h3>🎓 Matricular en etapa</h3>
              <p>
                Etapa: <b>{etapaSeleccionada?.nombre}</b>
              </p>
              <textarea
                rows={6}
                placeholder="Pegá DNIs"
                value={dnisTexto}
                onChange={(e) => setDnisTexto(e.target.value)}
                style={{ width: "100%" }}
              />
              <div style={{ marginTop: 10 }}>
                <button
                  className="pv-btn"
                  onClick={enviarMatricula}
                  disabled={enviando}
                >
                  {enviando ? "Enviando..." : "Enviar"}
                </button>
                <button
                  className="pv-btn pv-btn-secondary"
                  onClick={() => setModalMatricula(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
        <button
          className="pv-back"
          onClick={() => {
            setProcesoSeleccionado(null);
            setFormularioIdSeleccionado(null);
            setEtapaAbierta(null);
            setModuloProceso("etapas");
          }}
        >
          ← Volver
        </button>
        <section className="pv-process-hero">
          <div className="pv-process-hero-content">
            <span className="pv-eyebrow">Proceso seleccionado</span>
            <h2 className="pv-title">{procesoSeleccionado.nombre}</h2>
            {procesoSeleccionado.descripcion && (
              <p className="pv-process-description">
                {procesoSeleccionado.descripcion}
              </p>
            )}
            <div className="pv-process-meta">
              <span>Proceso #{procesoSeleccionado.id}</span>
              <span>
                Formulario: {formularioIdSeleccionado || "No configurado"}
              </span>
              <span>
                Etapas: {procesoSeleccionado.etapas?.length || 0}
              </span>
            </div>
          </div>
        </section>
        {mostrarEstadisticas && (
          <section style={{ margin: "18px 0 24px" }} aria-label="Estadísticas del proceso">
            <EstadisticasProceso
              procesoId={procesoSeleccionado.id}
              endpoint={`${API}/estadisticasProceso`}
            />
          </section>
        )}
        <div className="pv-process-actions">
          <button
            className="pv-btn pv-btn-excel"
            onClick={descargarExcelPostulaciones}
            disabled={!formularioIdSeleccionado}
          >
            📊 Descargar inscriptos al proceso
          </button>
        </div>
        {/* ===================================================== */}
        {/* MÓDULOS DEL PROCESO */}
        {/* ===================================================== */}
        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            margin: "20px 0",
            padding: 12,
            background: "#f4f7fb",
            borderRadius: 10,
            border: "1px solid #dce4ee",
          }}
        >
          <button
            className="pv-btn"
            onClick={() => setModuloProceso("etapas")}
            style={{ opacity: moduloProceso === "etapas" ? 1 : 0.65 }}
          >
            📋 Etapas del proceso
          </button>
          <button
            className="pv-btn"
            onClick={() => setModuloProceso("turnos")}
            style={{ opacity: moduloProceso === "turnos" ? 1 : 0.65 }}
          >
            📅 Turnos recursivos
          </button>
        </div>
        {loading && <p className="pv-loading-text">Cargando proceso...</p>}
        {moduloProceso === "etapas" && (
          <>
          <div className="pv-section-heading">
            <div>
              <span className="pv-eyebrow">Gestión del proceso</span>
              <h3>Etapas disponibles</h3>
            </div>
            <span className="pv-stage-count">
              {procesoSeleccionado.etapas?.length || 0}
            </span>
          </div>
          {procesoSeleccionado.etapas?.map((etapa) => {
            const abierta = etapaAbierta === etapa.id;
            return (
              <div key={etapa.id} className="pv-card">
                <div
                  className="pv-header"
                  onClick={() => setEtapaAbierta(abierta ? null : etapa.id)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setEtapaAbierta(abierta ? null : etapa.id);
                    }
                  }}
                >
                  <div className="pv-header-info">
                    <span className="pv-stage-icon">📌</span>
                    <div>
                      <span className="pv-stage-name">{etapa.nombre}</span>
                      <small>
                        {etapa.instancias?.length || 0} instancia
                        {(etapa.instancias?.length || 0) === 1 ? "" : "s"}
                      </small>
                    </div>
                  </div>
                  <span className="pv-toggle">{abierta ? "−" : "+"}</span>
                </div>
                {abierta && (
                  <div className="pv-body">
                    <div className="pv-actions">
                      <button
                        className="pv-btn"
                        onClick={() => {
                          setEtapaSeleccionada(etapa);
                          setDnisTexto("");
                          setModalMatricula(true);
                        }}
                      >
                        🎓 Matricular
                      </button>
                      <button
                        className="pv-btn"
                        onClick={() => {
                          setEtapaPresente(etapa);
                          setModalPresente(true);
                        }}
                      >
                        📷 Dar presente
                      </button>
                    </div>
                    {etapa.instancias?.length > 0 && (
                      <div className="pv-instances-section">
                        <span className="pv-subtitle">Instancias de la etapa</span>
                        <div className="pv-instances-grid">
                          {etapa.instancias.map((inst) => (
                            <div key={inst.id} className="pv-instancia">
                              <span>🧩</span>
                              <span>{inst.nombre}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="pv-inscriptos-section">
                      <ListadoInscriptosEtapa
                        etapa={etapa}
                        procesoSeleccionado={procesoSeleccionado}
                        dependenciaModulo={obtenerDependenciaPresente()}
                        presenteNuevo={presenteNuevo}
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })}          </>
        )}
        {moduloProceso === "turnos" && (
          <TurnosRecursivas
            procesoId={procesoSeleccionado.id}
            procesoNombre={procesoSeleccionado.nombre}
          />
        )}
      </div>
    );
  }
  return (
    <div className="pv-container">
      <section className="pv-page-header">
        <div>
          <span className="pv-eyebrow">Administración</span>
          <h1>Procesos de ingreso</h1>
          <p>
            Seleccioná un proceso para gestionar sus etapas, inscripciones,
            asistencias y exportaciones.
          </p>
        </div>
        <div className="pv-total-processes">
          <strong>{procesos.length}</strong>
          <span>procesos disponibles</span>
        </div>
      </section>
      {procesos.length === 0 ? (
        <div className="pv-empty-state">
          <span>📂</span>
          <h3>No hay procesos disponibles</h3>
          <p>No se encontraron procesos habilitados para tus permisos.</p>
        </div>
      ) : (
        <div className="pv-grid">
          {procesos.map((p) => {
            const formularioProceso =
              p?.formularioId || p?.formulario_id || null;
            return (
              <div
                key={p.id}
                className="pv-proceso-card"
                onClick={() => abrirProceso(p)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    abrirProceso(p);
                  }
                }}
              >
                <div className="pv-card-top">
                  <span className="pv-process-number">Proceso #{p.id}</span>
                  <span className="pv-open-indicator">Abrir →</span>
                </div>
                <h3>{p.nombre?.trim() ? p.nombre : `Proceso #${p.id}`}</h3>
                <p>
                  {p.descripcion?.trim()
                    ? p.descripcion
                    : "Sin descripción disponible"}
                </p>
                <div className="pv-card-footer">
                  <span>
                    📋 Formulario: {formularioProceso || "sin configurar"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default ProcesosViewer;
